<template>
  <div class="news-detail-container">
    <div class="d-flex">
      <display-image
        :imageId="content.imageId"
        class="news-image ma-auto mt-15 mb-15"
        :maxWidth="350"
      />
    </div>
    <h1 class="news-title">
      {{ content.title }}
    </h1>
    <div class="news-date">
      {{
        new Date(content.date).toLocaleDateString('uk-UA', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      }}
    </div>
    <page-control :model="content" />
  </div>
</template>
<script>
import DisplayImage from '../../_shared/DisplayImage.vue'
export default {
  components: {
    DisplayImage,
    PageControl: () => import('../../app/PageControl')
  },
  name: 'NewsDatils',
  props: {
    model: {
      required: true
    }
  },
  computed: {
    content: function() {
      return this.model
    }
  }
}
</script>
<style lang="scss" scoped>
.news-detail-container {
  max-width: 800px !important;
  margin-bottom: 10rem !important;
  .news-title {
    font-size: 3.6rem;
  }

  // .news-date,
  // .news-title {
  //   padding-left: 0.8rem;
  //   padding-right: 0.8rem;
  // }

  .news-date {
    font-size: 1.3rem;
    color: grey;
  }
}
</style>
